export function getIsRoleMenu(val){
  
  let menus =  sessionStorage.getItem('MENU')?JSON.parse(sessionStorage.getItem('MENU')):[]
  let result = false
  // 登录之后 没有同步这个 所以第一次这个地方是没有值的
  if(menus&&menus.length!=0){
    result = menus.find((v) => v.menuCode === val)
  }
  return result
}
